{
  "header": {
    "title": "Treasury / Company Ledger",
    "refresh": "Refresh"
  },
  "kpis": {
    "totalBase": "Total Base Principal",
    "totalWithdrawable": "Total Withdrawable",
    "totalUnsettledProfit": "Total Unsettled Profit",
    "companyBalance": "Company Balance",
    "totalPoolValue": "Total Pool Value",
    "poolValueDescription": "Base + Withdrawable + Unsettled + Company Balance",
    "activeUsers": "Active Users"
  },
  "liquidity": {
    "title": "Liquidity Planning - Next Settlement",
    "pendingWithdrawals": "Approved Pending Withdrawals",
    "projectedSettlement": "Projected Settlement Payout",
    "totalCashNeeded": "Total Cash Needed",
    "suggestedTransfer": "Suggested Bank Transfer",
    "transferIn": "Transfer funds IN from bank to platform",
    "transferOut": "Transfer funds OUT from platform to bank",
    "noTransfer": "No transfer needed"
  },
  "ledger": {
    "title": "Company Ledger Entries",
    "columns": {
      "date": "Date",
      "kind": "Type",
      "description": "Description",
      "amount": "Amount",
      "balance": "Balance After",
      "createdBy": "Created By"
    },
    "kinds": {
      "company_cut": "Company Cut",
      "fee_adjustment": "Fee Adjustment",
      "bank_transfer_out": "Transfer to Bank",
      "bank_transfer_in": "Transfer from Bank",
      "withdrawal_paid": "Withdrawal Paid",
      "correction": "Correction",
      "manual_adjustment": "Manual Adjustment",
      "company_cut_credited": "Company Cut Credited",
      "company_float_added": "Float Added",
      "company_withdrawable_added": "Withdrawable Added",
      "company_float_swept_to_withdrawable": "Float Swept",
      "company_sweep_paid_out": "Sweep Paid Out",
      "company_sweep": "Company Sweep",
      "company_deposit_received": "Deposit Received",
      "company_payout_sent": "Payout Sent",
      "company_payout_returned": "Payout Returned"
    }
  },
  "pool": {
    "title": "Pool Composition - Top 100 Active Users",
    "description": "Showing users with the largest balances to understand pool composition",
    "columns": {
      "rank": "#",
      "name": "Name",
      "base": "Base Principal",
      "withdrawable": "Withdrawable",
      "profitWeek": "Profit (Week)",
      "oneTime": "One-Time Withdrawable"
    }
  },
  "adjustment": {
    "button": "Manual Adjustment",
    "modalTitle": "Create Manual Ledger Entry",
    "kind": "Entry Type",
    "kindRequired": "Please select an entry type",
    "amount": "Amount (USD)",
    "amountRequired": "Please enter an amount",
    "description": "Description",
    "descriptionRequired": "Please enter a description",
    "descriptionPlaceholder": "Explain the reason for this adjustment...",
    "submit": "Create Entry",
    "cancel": "Cancel",
    "success": "Manual ledger entry created successfully"
  },
  "errors": {
    "fetchSummary": "Failed to load treasury summary",
    "fetchLedger": "Failed to load ledger entries",
    "createAdjustment": "Failed to create manual adjustment"
  }
}
